<template>
    <div class="text-center py-5">
        <i class="fa-solid fa-spinner fa-spin-pulse fa-7x"></i>
        <h3 class="mt-5 text-title-bat text-indigo">Estamos preparando tu contenido</h3>
    </div>
</template>

<script>
export default {

}
</script>
